"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const react_helmet_1 = __importDefault(require("react-helmet"));
const contexts_1 = require("@App/contexts");
const CreatePasswordForm_1 = __importDefault(require("@Scenes/UserRegistrationScenes/CreatePasswordScene/CreatePasswordForm"));
const ConfigurationMFA_1 = __importDefault(require("@Scenes/UserRegistrationScenes/CreatePasswordScene/ConfigurationMFA"));
const ConfirmSMSCode_1 = __importDefault(require("@Scenes/UserRegistrationScenes/CreatePasswordScene/ConfirmSMSCode"));
const create_password_status_1 = require("@App/enum/create-password-status");
const navigation_1 = __importDefault(require("@App/navigation"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const CreatePasswordScene = () => {
    const params = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { createPasswordStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const activateUser = () => __awaiter(void 0, void 0, void 0, function* () {
        const activatingCode = params.activatingCode;
        if (!activatingCode) {
            return;
        }
        try {
            setLoading(true);
            yield createPasswordStore.activateUser(activatingCode);
        }
        catch (error) {
            popupStore.setAlertFromError(error);
            navigate(navigation_1.default.login.root());
        }
        setLoading(false);
    });
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('create_password');
        activateUser().then();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: "Create password" }),
        react_1.default.createElement("main", { className: "create-password-scene" },
            loading && react_1.default.createElement(PointPreloader_1.default, null),
            !loading && createPasswordStore.createPasswordStatus === create_password_status_1.CreatePasswordStatus.setting_password && (react_1.default.createElement(CreatePasswordForm_1.default, { loading: loading, setLoading: setLoading })),
            !loading && createPasswordStore.createPasswordStatus === create_password_status_1.CreatePasswordStatus.configuration_mfa && (react_1.default.createElement(ConfigurationMFA_1.default, { loading: loading, setLoading: setLoading })),
            !loading && createPasswordStore.createPasswordStatus === create_password_status_1.CreatePasswordStatus.confirm_sms_code && (react_1.default.createElement(ConfirmSMSCode_1.default, { loading: loading, setLoading: setLoading })),
            !loading && createPasswordStore.createPasswordStatus === create_password_status_1.CreatePasswordStatus.config_done && (react_1.default.createElement("div", { className: "global-container" },
                react_1.default.createElement("div", { className: "after-create-pass" },
                    react_1.default.createElement("h3", null, "Password set!"),
                    react_1.default.createElement("p", null, "Your personal user account password has been set successfully."),
                    react_1.default.createElement(react_router_dom_1.NavLink, { to: '/login' }, "Go to Portal")))))));
};
exports.default = (0, mobx_react_1.observer)(CreatePasswordScene);
